import React from 'react'
import { node, string, bool } from 'prop-types'
import classNames from 'classnames'

import './Section.css'

function Section({ children, imageURL, imageAlt, inverted = false }) {
  const className = classNames('section', {
    'section--inverted': inverted,
  })

  return (
    <section className={className}>
      <div className="section__content">{children}</div>
      <div
        className="section__image"
        role="img"
        aria-label={imageAlt}
        style={{ backgroundImage: `url(${imageURL})` }}
      />
    </section>
  )
}

Section.propTypes = {
  children: node,
  imageURL: string,
  imageAlt: string,
  inverted: bool,
}

export { Section }
